/* eslint-disable */
export default {
  notActivated: 'Ei aktiivinen',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
